import {TaskState} from "./TaskState";
import {Action, handleActions} from "redux-actions";
import {none, option} from "ts-option";
import {TASK_CREATED, TASK_UPDATED, TASKS_FETCHED} from "../../action/task/actionType";

const initState: TaskState = {
	tasks: none
};

const reducer = handleActions({
	[TASKS_FETCHED]: (state: TaskState, action: Action<any>): TaskState => {
		return {...state, tasks: option(action.payload.tasks)}
	},
	[TASK_CREATED]: (state: TaskState, action: Action<TASK_CREATED>): TaskState => {
		return {
			...state, tasks: option(state.tasks.getOrElse([]).concat(action.payload.task))
		}
	},
	[TASK_UPDATED]: (state: TaskState, action: Action<TASK_UPDATED>): TaskState => {
		const tasks = state.tasks.getOrElse([]).map(
			t => t.id == action.payload.task.id ? action.payload.task : t);
		return {...state, tasks: option(tasks)}
	}
}, initState);

export default reducer;